/**
 * Define column widths based on the presence of previous dates and type of data
 * @param type
 * @param previousFirstDate
 * @param previousSecondDate
 * @param previousThirdDate
 */
export const defineCols = (
  type: 'resultsByTap' | 'tempDispenses' | 'tempCellars',
  previousFirstDate?: string | undefined,
  previousSecondDate?: string | undefined,
  previousThirdDate?: string | undefined
): string[] => {
  switch (type) {
    case 'tempDispenses': {
      return ['18%', '10%', '36%', '18%', '18%'];
    }
    case 'resultsByTap': {
      if (previousFirstDate) {
        if (previousSecondDate) {
          if (previousThirdDate) {
            return ['15%', '10%', '20%', '10%', '5%', '10%', '5%', '10%', '5%', '10%'];
          } else {
            return ['17.65%', '11.76%', '23.53%', '11.76%', '5.88%', '11.76%', '5.88%', '11.78%'];
          }
        } else {
          return ['21.43%', '14.29%', '28.57%', '14.29%', '7.14%', '14.28%'];
        }
      } else {
        return ['27.27%', '18.18%', '36.36%', '18.19%'];
      }
    }
    case 'tempCellars': {
      if (previousFirstDate) {
        if (previousSecondDate) {
          if (previousThirdDate) {
            return ['20%', '15%', '10%', '10%', '5%', '10%', '5%', '10%', '5%', '10%'];
          } else {
            return ['23.53%', '17.65%', '11.76%', '11.76%', '5.88%', '11.76%', '5.88%', '11.76%'];
          }
        } else {
          return ['28.57%', '21.43%', '14.29%', '14.29%', '7.14%', '14.29%'];
        }
      } else {
        return ['36.36%', '27.27%', '18.18%', '18.18%'];
      }
    }
  }
};
